const parseFeaturesForSelect = (features) => {
  return features?.map((feature) => ({
    label: feature?.properties?.name,
    value: feature?.properties?.gid,
  }));
};

const convertPlaceToBBox = (response) => {
  if (!response?.bbox?.length) {
    return null;
  }

  const [a, b, c, d] = response.bbox;

  return [
    [b, a],
    [d, c],
  ];
};

const convertPlaceToLatLngArray = (response) => {
  const feature = response?.features?.[0]?.geometry;

  if (!feature) {
    return null;
  }

  const { coordinates } = feature;

  if (!coordinates) {
    return null;
  }

  const [lng, lat] = coordinates;

  return [lat, lng];
};

const createMapFromListOfVenues = (responseVenues, responsePlaces) => {
  if (!responseVenues?.features?.length) {
    return new Map();
  }

  const { features } = responseVenues;

  const placesFeatures = responsePlaces?.features;

  const placesMap = new Map(
    placesFeatures?.map((feature) => [feature.properties?.gid, { ...feature.properties }])
  );

  const venuesMap = new Map(
    features.map((feature) => [
      feature.properties?.gid,
      {
        geometry: feature.geometry,
        properties: feature.properties,
        placeAggregatedInfo: placesMap.get(feature.properties?.gid),
      },
    ])
  );

  return venuesMap;
};

export {
  convertPlaceToBBox,
  parseFeaturesForSelect,
  convertPlaceToLatLngArray,
  createMapFromListOfVenues,
};
